import styled from '@emotion/styled';
import { Button, Flex } from 'antd';

export const BackButton = styled(Button)`
  width: 10rem;
  height: 3.5rem;
  font-size: 2rem;
  font-weight: bold;

  @media (max-width: 1024px) {
    width: 9rem;
    height: 3.25rem;
    font-size: 1.75rem;
  }

  @media (max-width: 768px) {
    width: 8rem;
    height: 3rem;
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    width: 6rem;
    height: 2.5rem;
    font-size: 1.25rem;
  }
`;

export const NextButton = styled(Button)<{
  $gradient?: string;
}>`
  &&& {
    width: 100vw;
    height: 100vw;
    border-radius: 50%;
    clip-path: circle(50% at 50% 50%);
    padding: unset;
    border: unset;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%) translateX(75%);
    background: ${({ $gradient }) => $gradient};

    &:hover {
      transform: translateY(-50%) translateX(75%) scale(1.0125);
      background: ${({ $gradient }) => $gradient};
    }

    @media (max-width: 768px) {
      width: 130vw;
      height: 130vw;
      top: unset;
      bottom: 0;
      transform: translateY(65%) translateX(55%);

      &:hover {
        transform: translateY(65%) translateX(55%) scale(1.0125);
      }
    }

    @media (max-width: 480px) {
      width: 130vw;
      height: 130vw;
      top: unset;
      bottom: 0;
      transform: translateY(50%) translateX(55%);

      &:hover {
        transform: translateY(50%) translateX(55%) scale(1.0125);
      }
    }
  }
`;

export const QuestionnaireContainer = styled.div<{
  $gradient?: string;
}>`
  width: 100%;
  height: 100%;
  padding: 48px 27.5% 128px 128px;
  background: ${({ $gradient }) => $gradient};
  display: flex;

  @media (max-width: 1024px) {
    padding: 48px 20% 96px 96px;
  }

  @media (max-width: 768px) {
    padding: 48px 48px 48px 48px;
  }

  @media (max-width: 480px) {
    padding: 48px 48px 48px 48px;
  }
`;

export const ButtonTextWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const ButtonText = styled.span`
  cursor: pointer;
  position: absolute;
  left: 12.5%;
  bottom: 30%;
  font-size: 2rem;
  font-weight: bold;
  color: #f2f2f2;
  user-select: none;

  @media (max-width: 1024px) {
    font-size: 1.75rem;
    left: 15%;
    bottom: 28%;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    left: unset;
    right: 8%;
    bottom: 17%;
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;

export const BeforeSDGsStageContainer = styled.div<{ $bgImage?: string }>`
  color: #f2f2f2;
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  ${({ $bgImage }) => $bgImage && `background-image: url(${$bgImage});`}
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  padding: 6rem;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    padding: 4rem;
  }

  @media (max-width: 768px) {
    grid-template-rows: 1fr auto 1.75fr;
  }

  @media (max-width: 480px) {
    padding: 3rem 4rem;
    min-height: 100vh;
    background-attachment: scroll;
    grid-template-rows: 1fr auto 1.5fr;
  }
`;

export const Logo = styled.img`
  height: 48px;
  width: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 40px;
  }

  @media (max-width: 480px) {
    height: 32px;
  }
`;

export const InfoTitle = styled.h1`
  font-size: 3rem;
  line-height: 1.3;
  margin: 0;
  font-weight: 600;

  @media (max-width: 1200px) {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.625rem;
    line-height: 1.25;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  max-width: 45%;
  margin: 0;

  @media (max-width: 1200px) {
    max-width: 50%;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
    max-width: 100%;
    margin-top: 1.5rem;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    line-height: 1.5;
    margin-top: 0;
  }
`;

export const TopSection = styled(Flex)`
  justify-content: end;
  gap: 2rem;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin-bottom: 2rem;
  }
`;

export const BottomSection = styled(Flex)`
  width: 100%;
  margin-bottom: 0;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 0;
  }

  @media (max-width: 480px) {
    align-items: center;
    margin-bottom: 0;
    gap: 1rem;
  }
`;

export const InfoLogoContainer = styled(Flex)`
  justify-content: end;

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled(Flex)`
  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    gap: 12px;
  }
`;

export const SDGsStageContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  row-gap: 40px;

  @media (max-width: 1024px) {
    row-gap: 35px;
  }

  @media (max-width: 768px) {
    row-gap: 30px;
  }

  @media (max-width: 480px) {
    row-gap: 20px;
  }
`;

export const Title = styled.div`
  font-size: 1.5rem;
  min-height: calc(1.5rem * 1.5);

  @media (max-width: 1024px) {
    font-size: 1.375rem;
    min-height: calc(1.375rem * 1.5);
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
    min-height: calc(1.25rem * 1.5);
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    min-height: calc(1.1rem * 1.5);
  }
`;

export const QuestionNumber = styled.div`
  font-size: 8rem;
  line-height: 1;
  font-weight: bold;

  @media (max-width: 1024px) {
    font-size: 6rem;
  }

  @media (max-width: 768px) {
    font-size: 4.5rem;
  }

  @media (max-width: 480px) {
    font-size: 3rem;
  }
`;

export const QuestionText = styled.span`
  font-size: 3rem;
  font-weight: 100;
  line-height: 1;
  white-space: pre-line;

  @media (max-width: 1024px) {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

export const QuestionInformation = styled.span`
  font-size: 1.25rem;
  font-weight: 100;
  line-height: 1;

  @media (max-width: 1024px) {
    font-size: 1.175rem;
  }

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const FormContainer = styled.div`
  display: grid;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    justify-content: stretch;
  }

  .radio-in-form-item {
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .ant-form-item {
    margin-bottom: 3rem;

    &.textarea-in-form-item {
      margin-top: auto;
    }

    @media (max-width: 1024px) {
      margin-bottom: unset;
    }

    @media (max-width: 768px) {
    }

    @media (max-width: 480px) {
    }
  }

  .ant-radio-group {
    display: flex;
    gap: 0.75rem;

    @media (max-width: 480px) {
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  .ant-radio-wrapper {
    font-size: 1.125rem;

    @media (max-width: 1024px) {
      font-size: 1.0625rem;
    }

    @media (max-width: 768px) {
      font-size: 1rem;
    }

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }

  .ant-input-textarea {
    font-size: 1rem;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }

  .ant-select {
    width: 100%;

    @media (max-width: 480px) {
      font-size: 0.9rem;
    }
  }
`;

export const QuestionnaireWrapper = styled(Flex)`
  && {
    width: 100%;
    margin-left: 16px;

    @media (max-width: 768px) {
      justify-content: flex-start;
    }
  }
`;

export const LogoContainer = styled(Flex)<{
  $show: boolean;
}>`
  @media (max-width: 768px) {
    display: ${({ $show }) => ($show ? 'none' : 'flex')};
  }

  @media (max-width: 480px) {
  }
`;

export const AnswerExampleTitle = styled.div`
  font-size: 1.25rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.875rem;
  }
`;

export const AnswerExampleRadio = styled.div`
  font-size: 1rem;
  width: fit-content;
  padding: 24px 48px;
  border: 1px solid #ffffff5a;
  border-radius: 48px;

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 16px 40px;
    justify-self: end;
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;
    padding: 12px 28px;
  }
`;

export const AnswerExampleText = styled.div`
  font-size: 0.875rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    text-align: left;
    justify-self: start;
  }

  @media (max-width: 480px) {
    font-size: 0.625rem;
  }
`;

export const MobileContainer = styled.div<{
  $gradient?: string;
}>`
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: 2.1fr 0.9fr;
  overflow: hidden;
  position: relative;
  background: ${({ $gradient }) => $gradient};
`;

export const MobileContentArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  padding: 10% 48px 0px 48px;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 12% 48px 0px 48px;
  }

  @media (max-width: 480px) {
    padding: 16% 48px 0px 48px;
  }
`;

export const MobileTitle = styled.div<{ $info: boolean }>`
  font-size: ${({ $info }) => ($info ? '5rem' : '2.5rem')};
  font-weight: 100;
  line-height: 1;
  white-space: pre-line;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: ${({ $info }) => ($info ? '4rem' : '1.5rem')};
    text-align: left;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
    margin-bottom: 4px;
  }
`;

export const MobileDescription = styled.div`
  font-size: 1rem;
  font-weight: 100;
  line-height: 1;
  white-space: pre-line;
  max-width: 600px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    text-align: left;
    margin-bottom: 24px;
  }

  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

export const MobileButtonArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const MobileBackButtonWrapper = styled.div`
  flex-shrink: 0;
`;

export const MobileNextButtonWrapper = styled.div``;

export const MobileAnswerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  column-gap: 24px;
`;
